<!-- 
A container for laying out data in a standard kinda way.

We use this for most of our non-tabular read-only data components (i.e. "panels")
-->
<template>
  <div>
    <v-container :class="{'our-dc-dense': dense, 'py-0': title, [css]: true}" :fluid="fluid">
      <v-layout :class="right ? 'text-xs-right' : ''" row wrap>
        <v-flex v-if="title" class="xs12 offset-xs1">
          <h3 class="title my-3">
            {{ title }}<span v-if="subtitle" class="body-1 pl-2">{{ subtitle }}</span>
          </h3>
        </v-flex>
        <slot/>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    dense: {
      default: false,
      type: Boolean
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    fluid: {
      type: Boolean,
      default: false
    },
    right: {
      default: false,
      type: Boolean
    },
    css: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
.field {
  margin-bottom: 16px;
}
.our-dc-dense {
  padding: 0 5px 0 5px;
  .subheading {
    font-size: 14px !important;
  }
  .field {
    margin-bottom: 10px;
  }
}
</style>